import { Component, ElementRef, EventEmitter, HostListener, inject, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AlterCasePipe } from '../../../_pipes/alter-case.pipe';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'mayne-custom-dropdown',
  templateUrl: './custom-dropdown.component.html',
  styleUrls: ['./custom-dropdown.component.scss'],
  providers: [AlterCasePipe], // Register the pipe as a provider

})
export class CustomDropdownComponent {


  protected readonly alterCase = inject(AlterCasePipe);

  faChevron = faChevronDown;

  @Input() basic: boolean = false;
  @Input() options: any;
  @Input() label: string = '';
  @Input() inputValue: any | null = null;
  @Input() placeholder: string = '';
  @Input() emptyVal: string = '';
  @Input() rightOnMob: boolean = false;
  @Input() disabled: boolean = false;
  @Input() index: string = '';
  @Input() searchable: boolean = true;
  @Input() changeCase: boolean = false;

  filteredOptions: any = [];


  intervalId: number = -1;
  @Output() currentValueChange = new EventEmitter();
  @Output() onEscPress = new EventEmitter<any>();
  @Output() onEnterPress = new EventEmitter<any>();
  @Output() reverseTab = new EventEmitter<any>();

  public currentValue: any;
  public currentValueValue: any;
  public dropdownOpen: boolean = false;
  @ViewChild('ngSelect') ngSelect?: NgSelectComponent;
  //public get dropdownElement(): Element { return this.elem.nativeElement.querySelector('.dropdown-list') }

  private currentIndex = -1;


  /*
    @HostListener('window:click', ['$event'])
    closeMenu(event: Event) {
      if (this.elem.nativeElement.contains(event.target)) {
        return;
      }
    //  this.closeDropdown();
    }
    */

  ngOnInit(): void {
    if (this.inputValue != null) {
      this.currentValue = this.options.find((x: any) => x.value == this.inputValue);
      this.currentValueValue = this.inputValue;
      return;
    }
    if (this.changeCase) {
      this.options.map((x: any) => {
        x.text = this.alterCase.transform(x.text as string, 'title');
      });
    }

    this.filteredOptions = this.options;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.inputValue == null) {
      this.currentValueValue = null;
    }


    if (this.inputValue != null && this.options.length > 0) {
      this.currentValue = this.options.find((x: any) => x.value == this.inputValue);
      this.currentValueValue = this.inputValue;

    }

    if (changes['changeCase'] && changes['changeCase'].currentValue) {
      this.options.map((x: any) => {
        x.text = this.alterCase.transform(x.text as string, 'title');
      });
    }

    if (changes['options']) {
      const prevOptions = changes['options'].previousValue;
      const currentOptions = changes['options'].currentValue;

      if (this.changeCase) {
        currentOptions.map((x: any) => {
          x.text = this.alterCase.transform(x.text as string, 'title');
        });
      }

      this.filteredOptions = [...currentOptions];
    }

  }

  handleKeyboardEvents($event: KeyboardEvent) {
    /*
    if (this.dropdownOpen) {
      $event.preventDefault();
    } else {
      return;
    }
    if ($event.code === 'ArrowUp') {
      if (this.currentIndex < 0) {
        this.currentIndex = 0;
      } else if (this.currentIndex > 0) {
        this.currentIndex--;
      }
      this.elem.nativeElement.querySelectorAll('li').item(this.currentIndex).focus();
    } else if ($event.code === 'ArrowDown') {
      if (this.currentIndex < 0) {
        this.currentIndex = 0;
      } else if (this.currentIndex < this.options.length - 1) {
        this.currentIndex++;
      }
      this.elem.nativeElement.querySelectorAll('li').item(this.currentIndex).focus();
    } else if (($event.code === 'Enter' || $event.code === 'NumpadEnter') && this.currentIndex >= 0) {
      this.selectByIndex(this.currentIndex);
    } else if ($event.code === 'Escape') {
      this.closeDropdown();
    }
    */
  }

  onKeyPress(event: KeyboardEvent) {
    console.log('onKeyPress', event.key);

    if (event.key == 'Tab' && event.shiftKey == true) {
      this.reverseTab.emit(event);
    }
    if (event.key == 'Escape') {
      this.onEscPress.emit(event);
    }
    if (event.key == 'Enter') {
      if (this.currentValue) {
        this.closeDropdown();
        this.onEnterPress.emit(this.currentValue);
      } else if (this.ngSelect) {
        this.ngSelect.open();
      }
    }
  }

  testEnter(event: KeyboardEvent) {
    if (event.key == 'Enter') {
      event.stopPropagation();
      event.preventDefault();

      if (this.currentValue) {
        this.closeDropdown();
        this.onEnterPress.emit(this.currentValue);
      } else if (this.ngSelect) {
        this.ngSelect.open();
      }
    }
  }



  closeDropdown() {
    console.log('closeDropdown');
    if (this.ngSelect) {
      this.ngSelect.close();
    }
    this.dropdownOpen = false;
    this.currentIndex = -1;
  }

  selectByIndex(i: number) {
    let value = this.options[i];
    this.select(value);
  }

  select(value: any) {
    console.log('select', value);
    // this.closeDropdown();
    this.currentValueChange.emit(value);
  }

  toggleDropdown() {
    //  this.dropdownOpen = !this.dropdownOpen;
    //  this.dropdownElement.setAttribute('aria-expanded', this.dropdownOpen ? "true" : "false");
  }

  doMouseOut(event: any) {
    //  this.intervalId = setTimeout(() => {
    //    this.closeDropdown();
    //  }, 3000, this)
  }
  doMouseOver(event: any) {
    //  clearInterval(this.intervalId);
  }

  // Function triggered by the search event in ng-select
  onSearch(searchText: any): any {

    // const filteredItems = this.options();

    if (searchText.term) {
      const lowerSearchText = (searchText.term + '').toLowerCase();

      this.filteredOptions.sort((a: any, b: any) => {
        const descA = a.text.toLowerCase();
        const descB = b.text.toLowerCase();

        // Prioritize items that start with the searchText
        const startsWithA = descA.startsWith(lowerSearchText) ? -1 : 1;
        const startsWithB = descB.startsWith(lowerSearchText) ? -1 : 1;

        if (startsWithA !== startsWithB) {
          return startsWithA - startsWithB;
        }

        // Next, prioritize items that include the searchText
        const includesA = descA.includes(lowerSearchText) ? -1 : 1;
        const includesB = descB.includes(lowerSearchText) ? -1 : 1;

        if (includesA !== includesB) {
          return includesA - includesB;
        }

        // If both are equal, maintain original order
        return 0;
      });
    }

    this.filteredOptions = [...this.filteredOptions];
    return searchText;

  }

}